import { useState } from "react";
import { api } from "../lib/api";
import { useAuthCtx } from "../hooks/AuthContext";

export function Account() {
  const { me } = useAuthCtx();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ kind: "ok" | "err"; text: string } | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg(null);
    if (next.length < 8) { setMsg({ kind: "err", text: "new password must be at least 8 characters" }); return; }
    if (next !== confirm) { setMsg({ kind: "err", text: "passwords do not match" }); return; }
    setBusy(true);
    try {
      await api.changePassword(current, next);
      setCurrent(""); setNext(""); setConfirm("");
      setMsg({ kind: "ok", text: "Password updated." });
    } catch (e) {
      setMsg({ kind: "err", text: (e as Error).message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md space-y-8">
      <div className="space-y-1">
        <div className="eyebrow">Account</div>
        <h1 className="font-display text-2xl">{me?.email}</h1>
        <div className="text-xs text-paper-500">{me?.is_admin ? "Administrator" : "Member"}</div>
      </div>

      <form onSubmit={submit} className="space-y-5">
        <h2 className="text-sm uppercase tracking-widest text-paper-600">Change password</h2>
        <div>
          <label className="label">Current password</label>
          <input type="password" className="input" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" />
        </div>
        <div>
          <label className="label">New password</label>
          <input type="password" className="input" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} autoComplete="new-password" />
        </div>
        <div>
          <label className="label">Confirm new password</label>
          <input type="password" className="input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} autoComplete="new-password" />
        </div>
        {msg ? <div className={`text-xs ${msg.kind === "ok" ? "text-green-700" : "text-red-700"}`}>{msg.text}</div> : null}
        <button type="submit" className="btn-primary" disabled={busy}>{busy ? "Saving…" : "Update password"}</button>
      </form>
    </div>
  );
}
